import { render, staticRenderFns } from "./HeaderNoLogin.vue?vue&type=template&id=45ce6a27&scoped=true"
import script from "./HeaderNoLogin.vue?vue&type=script&lang=js"
export * from "./HeaderNoLogin.vue?vue&type=script&lang=js"
import style0 from "./HeaderNoLogin.vue?vue&type=style&index=0&id=45ce6a27&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce6a27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ce6a27')) {
      api.createRecord('45ce6a27', component.options)
    } else {
      api.reload('45ce6a27', component.options)
    }
    module.hot.accept("./HeaderNoLogin.vue?vue&type=template&id=45ce6a27&scoped=true", function () {
      api.rerender('45ce6a27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/HeaderNoLogin.vue"
export default component.exports